import { AppTextButton } from "../../../global/ui/buttons";
import Link from "next/link";
import { useDispatch } from "react-redux";
import { setTabSection } from "../../../../redux/pages/exploreSlice";

export const BlogTopicsCoachesSeeMore = () => {
  const dispatch = useDispatch();

  return (
    <Link href={"explore"}>
      <AppTextButton
        className={"mt-4"}
        onClick={() => {
          dispatch(setTabSection(1));
        }}
      >
        See More Suggestions
      </AppTextButton>
    </Link>
  );
};
